// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3ize8","buttons":"SendReceipts_buttons__18T3L","email":"SendReceipts_email__3aWK3","bookApptTitle":"SendReceipts_bookApptTitle__uC6vu"};